export default __webpack_public_path__ + "static/fonts/D-DIN-PRO-600-SemiBold.956c449a.otf";